import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "reactstrap";
import currencies from "../../Currency/currency.json";
import { useDispatch, useSelector } from "react-redux";
import { makePurchase } from "../../redux/thunks/postThunks";
import { updateOrder, deleteOrder } from "../../redux/thunks/orderThunks";

const PostModal = ({ isOpen, toggle, post, mode, triggerRefresh }) => {
  const user = useSelector((state) => state.user.user.data);
  const paymentCards = user?.bankingInfo?.paymentCards || [];
  const depositAccounts = user?.bankingInfo?.depositAccounts || [];
  const dispatch = useDispatch();

  const [selectedCardId, setSelectedCardId] = useState("");
  const [selectedAccountId, setSelectedAccountId] = useState("");

  if (!post) return null;

  const isModify = mode === "modify";

  const handleBuy = () => {
    const selectedCard = paymentCards.find(
      (card) => `${card.brand} **** ${card.last4}` === selectedCardId
    );
    const selectedAccount = depositAccounts.find(
      (acc) => acc.bankAccountId === selectedAccountId
    );

    if (!selectedCard || !selectedAccount) {
      alert("Please select both a payment card and deposit account.");
      return;
    }

    const purchaseData = {
      postId: post.id,
      amountBuy: (post.amount * post.rate).toFixed(2),
      rate: post.rate,
      selectedCard,
      selectedAccount,
    };

    dispatch(
      makePurchase({ purchaseData, buyerEmail: user.email, userId: user.id })
    )
      .unwrap()
      .then((res) => {
        alert("Purchase successful!");
        toggle();
      })
      .catch((err) => {
        alert(err || "Purchase failed.");
      });
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>
        {isModify ? "Modify Post" : "Buy Post"}
      </ModalHeader>
      <ModalBody>
        <form>
          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label>I want to buy</label>
                <select
                  className="form-control"
                  disabled={!isModify}
                  value={post.secondary_currency}
                >
                  <option value={post.secondary_currency}>
                    {post.secondary_currency}
                  </option>
                  {isModify &&
                    currencies.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name}
                      </option>
                    ))}
                </select>
              </div>
            </Col>
            <Col xs={6}>
              <div className="form-group">
                <label>I want to sell</label>
                <select
                  className="form-control"
                  disabled={!isModify}
                  value={post.primary_currency}
                >
                  <option value={post.primary_currency}>
                    {post.primary_currency}
                  </option>
                  {isModify &&
                    currencies.map((c) => (
                      <option key={c.code} value={c.code}>
                        {c.name}
                      </option>
                    ))}
                </select>
              </div>
            </Col>
          </Row>

          <Row>
            <Col xs={6}>
              <div className="form-group">
                <label>Buy Amount</label>
                <input
                  type="text"
                  readOnly={!isModify}
                  className="form-control"
                  value={`${(post.amount * post.rate).toFixed(2)} ${
                    post.secondary_currency
                  }`}
                />
              </div>
            </Col>
            <Col xs={6}>
              <div className="form-group">
                <label>Sell Amount</label>
                <input
                  type="text"
                  readOnly={!isModify}
                  className="form-control"
                  value={`${post.amount} ${post.primary_currency}`}
                />
              </div>
            </Col>
          </Row>

          <div className="form-group">
            <label>Payment Method</label>
            <select
              className="form-control"
              disabled={false}
              value={selectedCardId}
              onChange={(e) => setSelectedCardId(e.target.value)}
            >
              <option value="">Select</option>
              {paymentCards.map((card) => (
                <option
                  key={card.id}
                  value={`${card.brand} **** ${card.last4}`}
                >
                  {`${card.brand} **** ${card.last4} (exp: ${card.expMonth}/${card.expYear})`}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>Deposit Account</label>
            <select
              className="form-control"
              disabled={false}
              value={selectedAccountId}
              onChange={(e) => setSelectedAccountId(e.target.value)}
            >
              <option value="">Select</option>
              {depositAccounts.map((account) => (
                <option
                  key={account.bankAccountId}
                  value={account.bankAccountId}
                >
                  {`${account.bankName} ****${account.accountNumber?.slice(
                    -4
                  )}`}
                </option>
              ))}
            </select>
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        {isModify ? (
          <div>
            <Button
              color="danger"
              onClick={() => {
                dispatch(deleteOrder(post.id)).then(() => {
                  triggerRefresh();
                  toggle();
                });
              }}
            >
              Delete
            </Button>
            {/* <Button
              color="primary"
              onClick={() => {
                dispatch(
                  updateOrder({
                    id: post.id,
                    max: formData.max,
                    rate: formData.rate,
                  })
                );
              }}
            >
              Confirm Modification
            </Button> */}
          </div>
        ) : (
          <Button color="success" onClick={handleBuy}>
            Confirm Purchase
          </Button>
        )}
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default PostModal;
